<template>
    <rkm-overlay>
        <rkm-layout-body title="Dispensação de materiais">
            <rkm-layout-content>
                <List>
                    <template #actions="{ item }">
                        <rkm-button
                            @click="redirectToDispensacao(item)"
                            class="align-self-end"
                            color="primary"
                            title="Dispensar"
                            small
                        >
                            <rkm-icon icon="hand-holding-medical"/>
                        </rkm-button>
                    </template>
                </List>
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/almoxarifado/dispensacao-materiais/List'

export default {
    components: {
        List
    },
    methods: {
        redirectToDispensacao(paciente) {

            if (paciente.diasCadastroDesatualizado > 0) {

                const confirm = async () => {

                    this.$nextTick().then(() => this.irParaDispensacao(paciente))

                    return false
                }

                let msg = `Paciente com cadastro desatualizado há <strong>${paciente.diasCadastroDesatualizado}</strong>
                    dia(s). Deseja continuar?`

                if (paciente.enderecoDesatualizadoBloqueado) {

                    msg = `Paciente com cadastro desatualizado há <strong>${paciente.diasCadastroDesatualizado}</strong>
                        dia(s). Endereço do usuário também deve ser atualizado. Deseja continuar?`
                }

                this.showConfirmation(msg, confirm)

                return false
            }

            this.irParaDispensacao(paciente)
        },
        irParaDispensacao(paciente) {

            if (paciente.enderecoDesatualizadoBloqueado) {

                this.showAlert(
                    'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                    'Atenção'
                )

                return
            }

            this.$router.push({ name: 'almoxarifado-dispensacao-materiais-create', params: { pacienteId: paciente.id }})
        },
    }
}
</script>